<template>
  <div class="login-wrap">
    <!-- <div class="header_logo">
      <el-image style="cursor:pointer" class="logo" @click="$router.push('/')" :src="logo" fit="fill">
        <div slot="error" class="image-slot">
          <i class="el-icon-picture-outline"></i>
        </div>
      </el-image>
    </div> -->
    <outsidetop></outsidetop>
    <div class="minddle bgo_image bgDiv">
      <!-- <el-image :src="indexInfo.backgrandImage" fit="fill" style="height:100%;width: -webkit-fill-available;">
        <div slot="error" class="image-slot">
          <i class="el-icon-picture-outline"></i>
        </div>
      </el-image> -->
      <div class="formBox">
        <div class="login_text">登录账号</div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
          <el-form-item prop="username">
            <el-input type="text" v-model="ruleForm.username" maxlength="11" :placeholder="$t('login.account')"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input type="password" show-password v-model="ruleForm.password" :placeholder="$t('login.password')" @keyup.enter.native="enterLogin('ruleForm')"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')" class="btn">登录</el-button>
            <!-- <el-button type="primary" @click="submitForm('ruleForm')">{{$t('login.Sign in')}}</el-button> -->
          </el-form-item>
        </el-form>
        <!-- <div class="textBox">
          <a class="passtext" @click="$router.push('/retrievePassword')">{{$t('login.retrieve password')}}</a>
          <el-divider direction="vertical"></el-divider>
          <a class="creatText" @click="$router.push('/register')">{{$t('login.Sign up now')}}</a>
        </div> -->
      </div>
    </div>
    <footernav></footernav>
    <!-- <div class="footer_info" v-if="showCopy">
      <p class="text-center" style="line-height: 30px;">{{informations.copyrightInformation}}
        <br>
        <a :href="informations.icpUrl" target="_blank">{{informations.icp}}</a>
      </p>
    </div> -->
  </div>
</template>
<script type="text/ecmascript-6">
import { login, copyRight, setImage, shoppingCartlist } from "@/api/xunyou";
import { setCookie, getCookie, delCookie } from "../utils/util";
import footernav from "../components/footernav.vue";
import outsidetop from "../components/outsideTop.vue";
import md5 from "js-md5";
export default {
  name: "login",
  components: {
    footernav,
    outsidetop
  },
  inject: ["postAlertInvoice"],
  data() {
    return {
      logo: "",
      indexInfo: {},
      //登录
      ruleForm: {
        //username和password默认为空
        username: "",
        password: "",
        isNotCode: true
      },
      informations: {},
      //rules前端验证
      rules: {
        username: [
          {
            required: true,
            message: this.$t("login.please enter account"),
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: this.$t("login.please enter account"),
            trigger: "blur"
          }
        ]
      },
      showCopy: false
    };
  },
  // 创建完毕状态(里面是操作)
  created() {
    // localStorage.removeItem("userdata");
    // this.$message({
    //   message: '账号密码及验证码不为空即可',
    //   type: 'success'
    // })
    // // 获取图形验证码
    // this.getcode()
    // // 获取存在本地的用户名密码
    // this.getuserpwd()
    // this.getImagelogo()
    this.geTCopyright();
  },
  // 里面的函数只有调用才会执行
  methods: {
    getshoppingCartlist(uid, userToken) {
      shoppingCartlist({
        uid: uid,
        userToken: userToken
      })
        .then(res => {
          if (res.code == "0") {
            this.$store.commit("getCartList", res.data);
          } else {
            if (res.code == "2001") {
              localStorage.removeItem("userdata");
              this.$router.push("/login");
            }
            this.$message({
              message: res.msg,
              type: "warning",
              duration: 2000
            });
          }
        })
        .catch(err => {
          console.log(err);
          // this.$message.error('购物车查询失败，请稍后再试！')
        });
    },
    // 获取logo
    getImagelogo() {
      setImage().then(res => {
        if (res.code == 0) {
          if (res.rows.length != 0) {
            this.showCopy = true;
            this.logo = res.rows[0].pcLogo;
            this.indexInfo = res.rows[0];
          }
        }
      });
    },
    // 获取版权名称
    geTCopyright() {
      copyRight()
        .then(res => {
          if (res.code == 0) {
            this.informations = res.rows[0];
            if (this.informations.powstatus == 1) {
              this.$router.push("/erroPage");
            } else {
              this.$store.commit("getcopyRight", this.informations);
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 获取用户名密码
    // getuserpwd() {
    //   if (getCookie('user') != '' && getCookie('pwd') != '') {
    //     this.ruleForm.username = getCookie('user')
    //     this.ruleForm.password = getCookie('pwd')
    //     this.rememberpwd = true
    //   }
    // },

    // 回车登录
    enterLogin() {
      this.submitForm();
    },
    //获取info列表
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          login(this.ruleForm)
            .then(res => {
              if (res.code == 0) {
                // 缓存用户个人信息
                localStorage.setItem("userdata", JSON.stringify(res.data));
                this.postAlertInvoice();
                //获取购物车数据
                this.getshoppingCartlist(res.data.userId, res.data.userToken);
                var getfullPath = localStorage.getItem("backFullPath");
                // console.log(getfullPath,"getfullPath");
                if (getfullPath) {
                  this.$router.push({ path: getfullPath });
                } else {
                  this.$router.push({ path: "/goodsList?page=newFlag" });
                }
                setTimeout(() => {
                  localStorage.removeItem("backFullPath");
                }, 20);
                this.$message({
                  type: "success",
                  message: this.$t("login.login successful"),
                  duration:1000
                });
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch(err => {
              this.loading = false;
              console.log(err);
            });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped lang='less'>
.btn {
  background: rgba(234, 10, 42, 1) !important;
  border-color: rgba(234, 10, 42, 0.8) !important;
  &:hover {
    background: rgba(234, 10, 42, 0.8) !important;
  }
}

.bgDiv {
  min-height: 0 !important;
  max-height: none;
  height: 700px;
  background: url("~@/assets/img/bg1.png") no-repeat;
  background-size: 100% auto;
  margin-bottom: 0px;
  background-position: left bottom;
}

.minddle {
  min-width: 100%;
  min-height: 50%;
}

/deep/ .logo img {
  width: 255px;
  height: 52px;
}

.login-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 100%;

  .header_logo {
    padding: 30px 140px;
    margin: auto;
  }
  .minddle {
    .formBox {
      border-radius: 6px;
      box-shadow: 0 0 12px rgba(0, 0, 0, 0.2);
      width: 450px;
      background: white;
      position: absolute;
      right: 180px;
      top: 15%;
      padding: 25px 45px;

      .login_text {
        margin-bottom: 20px;
        color: #333333;
        font-size: 20px;
      }
      button.el-button.el-button--primary {
        width: 100%;
        background-color: #394af8;
        border-color: #394af8;
      }
      button.el-button.el-button--primary:hover {
        background-color: #409eff;
        border-color: #409eff;
      }
      .textBox {
        text-align: right;
        font-size: 16px;
        a {
          color: #68b828;
          cursor: pointer;
        }
      }
    }
  }
  .footer_info {
    text-align: center;
    font-size: 14px;
    padding: 20px;
    p.text-center {
      color: #979898;
    }
  }
}

.login-container {
  border-radius: 10px;
  margin: 0px auto;
  width: 350px;
  padding: 30px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  text-align: left;
  box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1);
}

.title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
}

.remember {
  margin: 0px 0px 35px 0px;
}

.code-box {
  text-align: right;
}

.codeimg {
  height: 40px;
}
</style>


// WEBPACK FOOTER //
// src/views/login.vue